<div class="get-number-final-wrapper">
  <h4 class="header-text" translate>ORDER_NUMBER.CONFIRM_NUMBER</h4>


  <cc-get-number-order-details
    [pricing]="pricing"
    [selectedMsisdn]="selectedMsisdn"
    [initialSteps]="initialSteps"
  ></cc-get-number-order-details>

  <cc-card [card]="card$ | async"
           *ngIf="!initialSteps && (cardMetadata$ | async)?.attachable"
  ></cc-card>

  <cc-msisdn-label (submitLabel)="finalizeNumberOrdering()"
                   [placeholderText]="pricing.city + ' number'"
                   [initialValue]="initialSteps ? pricing.city + ' number' : ''"
                   [formWrapper]="labelForm">
  </cc-msisdn-label>

  <div class="buttons-wrapper">

    <button
      (click)="goBack()"
      [disabled]="isLoading"
      mat-raised-button
      class="finalize-button"
      type="button"
      color="info-full">
      {{'CANCEL' | translate}}
    </button>

    <button
      (click)="finalizeNumberOrdering()"
      [disabled]="isLoading"
      mat-raised-button
      class="finalize-button"
      type="button"
      color="primary-full">
      {{'ORDER_NUMBER.CONFIRM' | translate}}
    </button>

  </div>

</div>
